import React from "react";
import { withRouter } from "react-router-dom";

import { Button2 } from "@/ui2/atoms/Button";
import CardSecondary from "@/ui/Card/CardSecondary";
import images from "@/utils/images";

import "./styles.scss";

const PostSessionsSurveyConfirmation = (props) => {
  return (
    <div className="d-flex align-items-center tw:justify-center">
      <CardSecondary className="PssConfirmation d-flex flex-column align-items-center tw:justify-center">
        <img alt="heart hand icon" src={images("./icons/icn-hand-heart.png")} width="100" />
        <div className="py-4">
          <p className="PssConfirmation__title pb-4">Keep up the good work!</p>
          <p className="PssConfirmation__text pb-5">
            Thank you for your feedback, it helps us make sure you get the most out of your
            aptihealth experience. We’ll check in again soon.
          </p>
        </div>
        <Button2 onPress={() => props.history.push("/app/home")}>Done</Button2>
      </CardSecondary>
    </div>
  );
};

export default withRouter(PostSessionsSurveyConfirmation);
